<section class="order-popup modal-body p-0">
   <div class="loader-container" *ngIf="isLoading">
      <div class="d-flex justify-content-between align-items-center">
         <div>
            <div class="mb-1">
               <ngx-skeleton-loader count="1" appearance="line" animation="progress"
                  [theme]="{ height: '22px', width: '130px', margin: '0px' }">
               </ngx-skeleton-loader>
            </div>
            <div>
               <ngx-skeleton-loader count="1" appearance="line" animation="progress"
                  [theme]="{ height: '15px', width: '80px', margin: '0px' }"></ngx-skeleton-loader>
            </div>
         </div>

         <div>
            <ngx-skeleton-loader count="1" appearance="line" animation="progress"
               [theme]="{ height: '22px', width: '130px', margin: '0px' }">
            </ngx-skeleton-loader>
         </div>
      </div>
      <div class="mt-3">
         <ngx-skeleton-loader count="1" appearance="line" animation="progress"
            [theme]="{ height: '30px', width: '100%', margin: '0px' }"></ngx-skeleton-loader>
      </div>
      <div class="mt-3">
         <ngx-skeleton-loader count="1" appearance="line" animation="progress"
            [theme]="{ height: '30px', width: '100%', margin: '0px' }"></ngx-skeleton-loader>
      </div>
      <div class="mt-3">
         <ngx-skeleton-loader count="1" appearance="line" animation="progress"
            [theme]="{ height: '30px', width: '100%', margin: '0px' }"></ngx-skeleton-loader>
      </div>
      <div class="mt-3">
         <ngx-skeleton-loader count="1" appearance="line" animation="progress"
            [theme]="{ height: '30px', width: '100%', margin: '0px' }"></ngx-skeleton-loader>
      </div>
      <div class="mt-3">
         <ngx-skeleton-loader count="1" appearance="line" animation="progress"
            [theme]="{ height: '30px', width: '100%', margin: '0px' }"></ngx-skeleton-loader>
      </div>
   </div>

   <ng-container *ngIf="!isLoading">
      <div *ngIf="!isPlaceOrder">
         <div class="symbol-data-header">
            <div class="symbol-data-header_box">
               <div ngbDropdown>
                  <button [disabled]="isReview" class="account-box" type="button" id="dropdownBasic1" ngbDropdownToggle>
                     <img class="account-box-logo" [src]="selectedAccount?.logo_square_url" />
                     <p class="account-box-name">{{selectedAccount?.name}}</p>
                     <svg class="chevron" width="16" height="8" viewBox="0 0 16 8" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                           d="M7.64307 7.78884L0.893074 0.911642C0.699714 0.714865 0.702766 0.398215 0.899666 0.204612C1.09669 0.0111296 1.41334 0.0140598 1.6067 0.211205L7.99988 6.72488L14.3931 0.211205C14.5864 0.0140623 14.9031 0.0111321 15.1001 0.204612C15.2973 0.39811 15.3001 0.714777 15.1067 0.911645L8.35669 7.78884C8.17018 7.98658 7.82959 7.98712 7.64307 7.78884Z"
                           fill="#4D4D4D" />
                     </svg>
                  </button>
                  <div class="dropdown" ngbDropdownMenu>
                     <div class="dropdown-container">
                        <div (click)="selectAccount(accounts[i])" ngbDropdownItem
                           *ngFor="let account of accounts;index as i" class="flex align-item-center dropdown-item">
                           <button>
                              <img class="dropdown-logo" [src]="accounts[i]?.logo_square_url" />
                              <p class="dropdown-text">
                                 {{ accounts[i].name }}
                              </p>
                           </button>
                        </div>
                     </div>
                  </div>
               </div>

               <div *ngIf="isMobile" [ngClass]="action==='BUY'?'badge buy':'badge sell'">
                  {{action}}
               </div>

               <div *ngIf="action==='BUY'" class="account-balance">
                  <p class="text">Available balance:</p>
                  <p class="amount">{{selectedAccount?.total_balance ?(selectedAccount?.total_balance | currency:
                     selectedAccount?.currency):'--'}}</p>
               </div>

               <div *ngIf="action==='SELL'" class="account-balance">
                  <p class="text">Owned shares:</p>
                  <p class="amount">{{shareUnits ?? '--'}}</p>
               </div>


               <div *ngIf="!isMobile" [ngClass]="action==='BUY'?'badge buy':'badge sell'">
                  {{action}}
               </div>
            </div>

            <div *ngIf="isStockInfoLoading" class="mb-2">
               <ngx-skeleton-loader count="1" appearance="line" animation="progress"
                  [theme]="{ height: '35px', width: '100%', margin: '0px' }">
               </ngx-skeleton-loader>
            </div>

            <div *ngIf="!isStockInfoLoading && symbolData?.price" class="symbol">
               <div class="d-flex justify-content-between gap-2 align-items-center">
                  <p class="symbol-details">{{symbolData?.name ?? '--'}}</p>
                  <p class="symbol-text">{{symbolData?.symbol ?? '--'}}</p>
                  <p class="symbol-amount">{{symbolData?.price ?(symbolData?.price | currency:
                     symbolData?.currency :'symbol':'1.2-4'):'--'}}
                  </p>
                  <!-- <p class="symbol-amount">{{symbolData?.price ?symbolData?.price:'--'}} -->
                  <!-- </p> -->
               </div>

            </div>
         </div>

         <ng-container *ngIf="!isReview">
            <!-- if accounts not found or no eligible account found for trading -->
            <div class="error-container" *ngIf="showErrorBox()">
               <div *ngIf="!isStockInfoLoading" class="error-box">
                  <div class="error-circle">
                     <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.5" y="0.5" width="49" height="49" rx="24.5" fill="white" />
                        <rect x="0.5" y="0.5" width="49" height="49" rx="24.5" stroke="#F5EEDC" />
                        <path
                           d="M27.5517 16.6667C27.2867 16.2267 26.9124 15.8627 26.4653 15.61C26.0181 15.3573 25.5132 15.2245 24.9996 15.2245C24.4859 15.2245 23.981 15.3573 23.5339 15.61C23.0867 15.8627 22.7125 16.2267 22.4475 16.6667L14.2392 30.0729C13.9639 30.526 13.8141 31.0442 13.8051 31.5743C13.7961 32.1044 13.9283 32.6274 14.188 33.0896C14.4477 33.5517 14.8257 33.9366 15.2831 34.2045C15.7406 34.4725 16.2611 34.6141 16.7912 34.6146H33.2079C33.7381 34.6141 34.2586 34.4725 34.716 34.2045C35.1735 33.9366 35.5514 33.5517 35.8112 33.0896C36.0709 32.6274 36.203 32.1044 36.194 31.5743C36.185 31.0442 36.0352 30.526 35.76 30.0729L27.5517 16.6667Z"
                           fill="#E43E3E" />
                        <path
                           d="M25 27.8646C24.7936 27.8619 24.5965 27.7787 24.4506 27.6328C24.3046 27.4869 24.2214 27.2897 24.2188 27.0834V22.3959C24.2188 22.1887 24.3011 21.99 24.4476 21.8434C24.5941 21.6969 24.7928 21.6146 25 21.6146C25.2072 21.6146 25.4059 21.6969 25.5524 21.8434C25.6989 21.99 25.7812 22.1887 25.7812 22.3959V27.0834C25.7786 27.2897 25.6954 27.4869 25.5494 27.6328C25.4035 27.7787 25.2064 27.8619 25 27.8646Z"
                           fill="white" />
                        <path
                           d="M24.9997 30.7292C25.575 30.7292 26.0413 30.2628 26.0413 29.6875C26.0413 29.1122 25.575 28.6459 24.9997 28.6459C24.4244 28.6459 23.958 29.1122 23.958 29.6875C23.958 30.2628 24.4244 30.7292 24.9997 30.7292Z"
                           fill="white" />
                     </svg>
                  </div>

                  <div *ngIf="showBrokerageError()">
                     <p class="error-heading">Selected Brokerage Not Supported</p>
                     <p class="error-text">{{selectedAccount?.name}} does not support trading {{symbolData?.name}}
                        stock.
                        Kindly switch account or <button (click)="openSupportedBrokeragesModal()"
                           class="error-connect_btn">connect</button> a new one.</p>
                  </div>

                  <div *ngIf="showHoldingError()">
                     <p class="error-heading">Holding not found</p>
                     <p class="error-text">{{symbolData?.name}} stock is not found for sell in your selected account's
                        holdings. Kindly switch your account.</p>
                  </div>

                  <div *ngIf="showSymbolError()">
                     <p class="error-heading">Ticker not found</p>
                     <p class="error-text">We were unable to fetch the stock details from your selected brokerage.</p>
                  </div>
               </div>

               <div *ngIf="isStockInfoLoading" class="mb-2 box-loader">
                  <ngx-skeleton-loader count="1" appearance="line" animation="progress"
                     [theme]="{ height: '100px', width: '100%', margin: '0px' }">
                  </ngx-skeleton-loader>
               </div>
            </div>

            <!-- If selected account is eligible but market is not open  -->
            <div class="warning-container" *ngIf="showWarningBox()">
               <div *ngIf="!isMarketStatusLoading" class="warning-box">
                  <div class="warning-circle">
                     <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.5" y="0.5" width="49" height="49" rx="24.5" fill="white" />
                        <rect x="0.5" y="0.5" width="49" height="49" rx="24.5" stroke="#F5EEDC" />
                        <path
                           d="M32.3177 21.2385L33.0281 20.5281C33.1276 20.432 33.207 20.3171 33.2616 20.19C33.3162 20.0629 33.3449 19.9262 33.3461 19.7879C33.3473 19.6496 33.3209 19.5124 33.2686 19.3844C33.2162 19.2564 33.1388 19.1401 33.041 19.0423C32.9432 18.9445 32.8269 18.8671 32.6989 18.8147C32.5709 18.7624 32.4337 18.736 32.2954 18.7372C32.1571 18.7384 32.0204 18.7671 31.8933 18.8217C31.7662 18.8763 31.6513 18.9557 31.5552 19.0552L30.8448 19.7656C29.4653 18.6584 27.7995 17.9662 26.0417 17.7698V15.625H27.0833C27.3596 15.625 27.6246 15.5152 27.8199 15.3199C28.0153 15.1245 28.125 14.8596 28.125 14.5833C28.125 14.307 28.0153 14.0421 27.8199 13.8467C27.6246 13.6514 27.3596 13.5416 27.0833 13.5416H22.9167C22.6404 13.5416 22.3755 13.6514 22.1801 13.8467C21.9848 14.0421 21.875 14.307 21.875 14.5833C21.875 14.8596 21.9848 15.1245 22.1801 15.3199C22.3755 15.5152 22.6404 15.625 22.9167 15.625H23.9583V17.7698C22.2005 17.9662 20.5347 18.6584 19.1552 19.7656L18.4448 19.0552C18.2483 18.8654 17.9852 18.7604 17.7121 18.7628C17.439 18.7652 17.1777 18.8747 16.9846 19.0679C16.7914 19.261 16.6819 19.5223 16.6795 19.7954C16.6771 20.0685 16.7821 20.3316 16.9719 20.5281L17.6823 21.2385C16.5782 22.6172 15.886 24.2798 15.6856 26.0347C15.4851 27.7897 15.7845 29.5655 16.5493 31.1577C17.314 32.7499 18.513 34.0937 20.0081 35.0342C21.5033 35.9747 23.2337 36.4737 25 36.4737C26.7663 36.4737 28.4967 35.9747 29.9919 35.0342C31.487 34.0937 32.686 32.7499 33.4507 31.1577C34.2155 29.5655 34.5149 27.7897 34.3144 26.0347C34.114 24.2798 33.4218 22.6172 32.3177 21.2385ZM27.8198 29.9031C27.6245 30.0984 27.3596 30.2081 27.0833 30.2081C26.8071 30.2081 26.5422 30.0984 26.3469 29.9031L24.2635 27.8198C24.0682 27.6244 23.9584 27.3595 23.9583 27.0833V22.9166C23.9583 22.6404 24.0681 22.3754 24.2634 22.1801C24.4588 21.9847 24.7237 21.875 25 21.875C25.2763 21.875 25.5412 21.9847 25.7366 22.1801C25.9319 22.3754 26.0417 22.6404 26.0417 22.9166V26.652L27.8198 28.4302C28.0151 28.6255 28.1248 28.8904 28.1248 29.1666C28.1248 29.4428 28.0151 29.7077 27.8198 29.9031Z"
                           fill="#E58908" />
                     </svg>
                  </div>
                  <p class="warning-heading">Non Trading Hours</p>
                  <p class="warning-text">{{marketCloseReason}}</p>
               </div>

               <div *ngIf="isMarketStatusLoading" class="mb-2 box-loader">
                  <ngx-skeleton-loader count="1" appearance="line" animation="progress"
                     [theme]="{ height: '100px', width: '100%', margin: '0px' }">
                  </ngx-skeleton-loader>
               </div>
            </div>

            <!-- Form -->
            <ng-container *ngIf="showForm()">
               <div *ngIf="!isReview && !isStockInfoLoading">
                  <form (ngSubmit)="submitForm()" [formGroup]="tradeImpactForm" class="order-popup_form">
                     <div>
                        <div class="input-box">
                           <label for="order-type" class="form-label form-label-lg">Order Type:</label>
                           <div class="d-flex align-items-center gap-3 justify-content-end action-button_box">
                              <button type="button" (click)="changeTypeButton('Market')" class="action-button"
                                 [ngClass]="
                              tradeImpactForm.get('type')?.value === 'Market'
                                 ? 'action-button_filled gradient-btn action-button-border'
                                 : 'gradient-border'
                           ">
                                 Market
                              </button>
                              <button type="button" (click)="changeTypeButton('Limit')" class="action-button" [ngClass]="
                              tradeImpactForm.get('type')?.value === 'Limit'
                                 ? 'action-button_filled gradient-btn action-button-border'
                                 : 'gradient-border'
                           ">
                                 Limit
                              </button>
                           </div>
                        </div>

                        <div class="input-box">
                           <label>Buy In:</label>
                           <select ngbTooltip="Your selected brokerage doesn't support buying in specific amounts."
                              disabled class="form-select input shadow-none" aria-label="Default select example">
                              <option value="units">Shares</option>
                              <option *ngIf="selectedAccount?.is_fraction_support && isNotionalValueSupports"
                                 value="units">
                                 Amount
                              </option>
                           </select>
                        </div>

                        <div *ngIf="tradeImpactForm.get('buyIn')?.value === 'units'" class="input-box">
                           <label for="units" class="form-label">Shares:</label>
                           <ng-container *ngIf="selectedAccount?.is_fraction_support">
                              <input onlyNumbersAndDot formControlName="units" type="text" class="form-control input"
                                 id="units" placeholder="Enter shares" />
                           </ng-container>

                           <ng-container *ngIf="!selectedAccount?.is_fraction_support">
                              <input onlyNumbersTooltip formControlName="units" type="text" class="form-control input"
                                 id="units" placeholder="Enter shares" />
                           </ng-container>
                        </div>

                        <div *ngIf="tradeImpactForm.get('buyIn')?.value === 'amount'" class="input-box">
                           <label for="amount" class="form-label">Amount:</label>
                           <input onlyNumbers formControlName="notional_value" type="text" class="form-control input"
                              id="amount" placeholder="Enter amount" />
                        </div>

                        <div *ngIf="tradeImpactForm.get('type')?.value === 'Limit'" class="input-box">
                           <label for="price" class="form-label">Price Per Share:</label>
                           <input formControlName="price" onlyNumbersAndDot type="text" class="form-control input"
                              id="price" placeholder="{{ this.symbolData?.price }}" />
                        </div>

                        <div *ngIf="tradeImpactForm.get('type')?.value === 'Limit'" class="input-box">
                           <label>Time In Force:</label>
                           <select formControlName="tif" class="form-select input shadow-none"
                              aria-label="Default select example">
                              <option value="GTC">Good Til Canceled</option>
                              <option value="Day">DAY</option>
                              <option value="FOK">Fill Or Kill</option>
                           </select>
                        </div>
                     </div>

                     <div>
                        <div *ngIf="tradeImpactForm.get('buyIn')?.value === 'units'"
                           class="d-flex justify-content-between align-items-center mt-3 mb-3 estimated-box">
                           <h5 class="estimated-text">Estimated Amount</h5>
                           <h5 class="estimated-text">
                              <!-- {{
                           estimated.toFixed(2) === "NaN"
                           ? 0.0
                           : estimated.toFixed(2)
                           }} {{ " " }} {{ this.accountCurrency }} -->

                              {{estimated | currency:
                              selectedAccount?.currency :'symbol':'1.2-3'}}
                           </h5>
                        </div>

                        <div *ngIf="tradeImpactForm.get('buyIn')?.value === 'amount'"
                           class="d-flex justify-content-between align-items-center mt-3">
                           <h5>Estimated Shares</h5>
                           <h5>
                              {{
                              estimated.toFixed(2) === "NaN"
                              ? 0.0
                              : estimated.toFixed(2)
                              }}
                              {{ " " }}
                              Shares
                           </h5>
                        </div>
                     </div>

                     <div *ngIf="status!=='COMPLIANT' && action==='BUY'" class="error-form-container">
                        <div class="error-form-box">
                           <div class="error-form-circle">
                              <svg width="50" height="50" viewBox="0 0 50 50" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                 <rect x="0.5" y="0.5" width="49" height="49" rx="24.5" fill="white" />
                                 <rect x="0.5" y="0.5" width="49" height="49" rx="24.5" stroke="#F5EEDC" />
                                 <path
                                    d="M27.5517 16.6667C27.2867 16.2267 26.9124 15.8627 26.4653 15.61C26.0181 15.3573 25.5132 15.2245 24.9996 15.2245C24.4859 15.2245 23.981 15.3573 23.5339 15.61C23.0867 15.8627 22.7125 16.2267 22.4475 16.6667L14.2392 30.0729C13.9639 30.526 13.8141 31.0442 13.8051 31.5743C13.7961 32.1044 13.9283 32.6274 14.188 33.0896C14.4477 33.5517 14.8257 33.9366 15.2831 34.2045C15.7406 34.4725 16.2611 34.6141 16.7912 34.6146H33.2079C33.7381 34.6141 34.2586 34.4725 34.716 34.2045C35.1735 33.9366 35.5514 33.5517 35.8112 33.0896C36.0709 32.6274 36.203 32.1044 36.194 31.5743C36.185 31.0442 36.0352 30.526 35.76 30.0729L27.5517 16.6667Z"
                                    fill="#E43E3E" />
                                 <path
                                    d="M25 27.8646C24.7936 27.8619 24.5965 27.7787 24.4506 27.6328C24.3046 27.4869 24.2214 27.2897 24.2188 27.0834V22.3959C24.2188 22.1887 24.3011 21.99 24.4476 21.8434C24.5941 21.6969 24.7928 21.6146 25 21.6146C25.2072 21.6146 25.4059 21.6969 25.5524 21.8434C25.6989 21.99 25.7812 22.1887 25.7812 22.3959V27.0834C25.7786 27.2897 25.6954 27.4869 25.5494 27.6328C25.4035 27.7787 25.2064 27.8619 25 27.8646Z"
                                    fill="white" />
                                 <path
                                    d="M24.9997 30.7292C25.575 30.7292 26.0413 30.2628 26.0413 29.6875C26.0413 29.1122 25.575 28.6459 24.9997 28.6459C24.4244 28.6459 23.958 29.1122 23.958 29.6875C23.958 30.2628 24.4244 30.7292 24.9997 30.7292Z"
                                    fill="white" />
                              </svg>
                           </div>

                           <div>
                              <p class="error-form-heading">Shariah status of {{symbolData?.symbol}} is:
                                 <span class="fw-bold">{{complianceText}}</span>
                              </p>
                              <p class="error-form-text">
                                 Musaffa advises against investing in stocks that do not align with Shariah principles.
                                 <button (click)="openComplianceReportTab()" type="button"
                                    class="p-0 error-form-button btn shadow-none text-decoration-underline">View
                                    Shariah Compliance
                                    Report</button>
                              </p>
                           </div>
                        </div>

                        <div *ngIf="isStockInfoLoading" class="mb-2 box-loader">
                           <ngx-skeleton-loader count="1" appearance="line" animation="progress"
                              [theme]="{ height: '100px', width: '100%', margin: '0px' }">
                           </ngx-skeleton-loader>
                        </div>
                     </div>


                     <button type="submit" [disabled]="isFormNotValid()" class="gradient-btn order-popup_form_submit">
                        <div class="spinner-border spinner-border-sm me-2" role="status" *ngIf="isReviewLoading">
                           <span class="visually-hidden">Loading...</span>
                        </div>
                        <span>{{ isReviewLoading ? 'Reviewing...' : 'Review Order' }}</span>
                     </button>
                  </form>
               </div>
            </ng-container>
         </ng-container>

         <div class="review" *ngIf="isReview">
            <div class="input-box">
               <p>Action:</p>
               <p>
                  {{ tradeImpactData?.action }}
               </p>
            </div>

            <div class="input-box">
               <p>Order Type:</p>
               <p>
                  {{ tradeImpactData?.type }}
               </p>
            </div>

            <div *ngIf="tradeImpactData?.type === 'Limit'" class="input-box">
               <p>Price Per Share:</p>
               <p>
                  {{ tradeImpactData?.price | currency:
                  tradeImpactData?.currency :'symbol':'1.2-3' }}
               </p>
            </div>

            <div class="input-box">
               <p>Time In Force:</p>
               <p>
                  {{
                  tradeImpactData?.time_in_force === "GTC"
                  ? "Good Till Canceled"
                  : tradeImpactData?.time_in_force === "FOK"
                  ? "Fill Or Kill"
                  : tradeImpactData?.time_in_force
                  }}
               </p>
            </div>

            <!-- <div *ngIf="tradeImpactForm.get('buyIn')?.value === 'units'" class="input-box">
               <p>Share:</p>
               <p>
                  {{ tradeImpactData?.units + " Shares" }}
               </p>
            </div>

            <div *ngIf="tradeImpactForm.get('buyIn')?.value === 'amount'" class="input-box">
               <p>Amount:</p>
               <p>
                  {{ tradeImpactData?.amount ?tradeImpactData?.amount + " $" : estimated.toFixed(2)
                  + " Shares" }}

               </p>
            </div> -->

            <div *ngIf="tradeImpactForm.get('buyIn')?.value === 'amount'" class="input-box">
               <p>Estimates Order Value:</p>
               <p>
                  {{tradeImpactForm.get('notional_value')?.value | currency:
                  tradeImpactData?.currency :'symbol':'1.2-3'}}
               </p>
            </div>

            <div *ngIf="tradeImpactForm.get('buyIn')?.value === 'units'" class="input-box">
               <p>Estimates Order Value:</p>
               <p>
                  {{estimated | currency:
                  tradeImpactData?.currency :'symbol':'1.2-3'}}
               </p>
            </div>

            <!-- <div>
               <p>Remaining cash:</p>
               <p>
                  {{ tradeImpactData?.account_remaining_cash | currency:
                  tradeImpactData?.currency }}
               </p>
            </div> -->

            <!-- <div class="d-flex justify-content-between align-item-center mt-2">
               <div class="review-info">
                  <p class="review-label">Remaining cash</p>
                  <p class="review-text">
                     {{ tradeImpactData?.account_remaining_cash | currency:
                     tradeImpactData?.currency }}
                  </p>
               </div>

               <div class="review-info">
                  <p class="review-label">Estimated order value</p>
                  <p *ngIf="tradeImpactForm.get('buyIn')?.value==='units'" class="review-text">
                     {{ estimated | currency:
                     tradeImpactData?.currency }}
                  </p>

                  <p class="review-label" *ngIf="tradeImpactForm.get('buyIn')?.value==='amount'" class="review-text">
                     {{ tradeImpactForm.get('notional_value')?.value | currency:
                     tradeImpactData?.currency }}
                  </p>
               </div>
            </div> -->




            <div class="d-flex justify-content-center align-items-center gap-3 mt-3">
               <button (click)="isReview=false" class="action-button gradient-border">
                  Edit
               </button>
               <button (click)="placeOrder()"
                  class="action-button action-button_filled gradient-btn action-button-border">
                  <div class="spinner-border spinner-border-sm me-2" role="status" *ngIf="isPlaceOrderLoading">
                     <span class="visually-hidden">Loading...</span>
                  </div>
                  <span>{{ isPlaceOrderLoading ? 'Placing Order...' : 'Place Order' }}</span>
               </button>
            </div>
         </div>
      </div>





      <div class="place-order" *ngIf="!isReview && isPlaceOrder">
         <div class="order-popup_checkmark">
            <div class="d-flex flex-column justify-content-center align-items-center w-100">
               <svg class="checkmark success mb-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                  <circle class="checkmark_circle_success" cx="26" cy="26" r="25" fill="none" />
                  <path class="checkmark_check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" stroke-linecap="round" />
               </svg>
               <p class="checkmark-heading mt-3">Congratulations!</p>
               <p class="checkmark-text mt-2">
                  {{placeOrderData?.order_status==='EXECUTED'? "Your Order has been placed successfully!":"Your order
                  has been placed. We'll notify you once your brokerage updates us about its execution."}}
               </p>
               <div
                  class="btns-wrapper d-flex align-items-center justify-content-center flex-wrap gap-2 gap-lg-3 my-3 w-100">
                  <button (click)="closePopup()" class="gradient-btn checkmark-button">
                     Okay
                  </button>
               </div>
            </div>
         </div>
      </div>
   </ng-container>

   <!-- <div class="order-popup_checkmark" *ngIf="!isLoading && isPlaceOrder">
         <div class="d-flex flex-column justify-content-center align-items-center">
            <svg class="checkmark success mb-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
               <circle class="checkmark_circle_success" cx="26" cy="26" r="25" fill="none" />
               <path class="checkmark_check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" stroke-linecap="round" />
            </svg>
            <p class="text-success mt-2">
               Your Order has been placed successfully!
            </p>
            <div class="btns-wrapper d-flex align-items-center justify-content-center flex-wrap gap-2 gap-lg-3 my-3">
            </div>
         </div>
      </div> -->

   <!-- <div *ngIf="!isMarketOpen && !isLoading">
      <div class="order-popup_nodata" *ngIf="!symbolData">
         <p>{{ marketCloseReason }}</p>
      </div>
   </div> -->
</section>

<!-- <div *ngIf="!isLoading && !isReview">
            <div class="order-popup_nodata" *ngIf="!symbolData">
               <p>Something went wrong please try again</p>
            </div>
            <div *ngIf="symbolData">
            

               
            </div>
         </div> -->



<!--    <div class="symbol-data-header">
                  <div class="d-flex justify-content-between align-items-center pb-2">
                     <div ngbDropdown>
                        <button class="account-box" type="button" id="dropdownBasic1" ngbDropdownToggle>
                           <img src="{{ selectedAccount.logo_url }}" />

                           <svg class="chevron" width="16" height="8" viewBox="0 0 16 8" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <path
                                 d="M7.64307 7.78884L0.893074 0.911642C0.699714 0.714865 0.702766 0.398215 0.899666 0.204612C1.09669 0.0111296 1.41334 0.0140598 1.6067 0.211205L7.99988 6.72488L14.3931 0.211205C14.5864 0.0140623 14.9031 0.0111321 15.1001 0.204612C15.2973 0.39811 15.3001 0.714777 15.1067 0.911645L8.35669 7.78884C8.17018 7.98658 7.82959 7.98712 7.64307 7.78884Z"
                                 fill="#4D4D4D" />
                           </svg>
                        </button>

                        <div class="dropdown" ngbDropdownMenu aria-labelledby="dropdownBasic1">
                           <div class="dropdown-container">
                              <div class="flex align-item-center gap-2 dropdown-item">

                                 <button ngbDropdownItem *ngFor="
                                 let account of accountsData;
                                 let i = index
                              ">
                                    <p class="dropdown-text" (click)="selectedAccount = accountsData[i]">
                                       {{ accountsData[i].name }}
                                    </p>
                                 </button>
                              </div>
                           </div>
                        </div>
                     </div>

                     <div class="account-balance">
                        <p class="text">Available balance</p>
                        <p class="amount">{{accountBalance}}$</p>
                        currency should not be hard coded
                     </div>
                  </div>

                  <div class="pb-3 symbol">
                     <div class="d-flex justify-content-between align-items-center pb-1">
                        <p class="symbol-details">{{symbolData.description}}</p>
                        <p class="symbol-amount">{{stockPrice}}</p>
                     </div>
                     <p class="symbol-text">{{symbolData.symbol}}</p>
                  </div>
               </div> -->